/**
 * @name RowsPerPage
 * @description Control de registros por página del datagrid
 * @author Ricardo Guerra
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Material-UI
import MuiTablePagination from '@material-ui/core/TablePagination';
import { withStyles } from '@material-ui/core/styles';

import { Icons, Theme, Typography } from '../../../../styles';

const RowsPerPage = (props) => {
  const {
    rowsLength,
    pageSize,
    currentPage,
    onChangePageSize,
  } = props;
  return (
    <Styled.FlexTablePagination>
      <Typography.Small color="greyDarkAlpha">{`Mostrar: `}</Typography.Small>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50, 100]}
        component="div"
        count={rowsLength}
        rowsPerPage={pageSize}
        page={currentPage}
        onPageChange={() => null}
        onRowsPerPageChange={onChangePageSize}
        labelRowsPerPage={''}
        labelDisplayedRows={({ count }) => {
          const items = count !== 1
            ? 'Elementos'.toLowerCase()
            : 'Elemento'.toLowerCase();
          const label =
            <span>
              {'de'}
              <Typography.Medium style={{ fontSize: '16px' }}>{` ${count} `}</Typography.Medium>
              {items}
            </span>;
          return label;
        }}
        SelectProps={{
          // eslint-disable-next-line react/display-name
          IconComponent: () => <Icons.ArrowDown />
        }}
      />
    </Styled.FlexTablePagination>
  );
};

RowsPerPage.propTypes = {
  // Longitud de registros.
  rowsLength: PropTypes.number,
  // Número de registro por página. 
  pageSize: PropTypes.number,
  // Número de página actual.
  currentPage: PropTypes.number,
  // Función a ejecutar cuando se cambie el número de registros por página.
  onChangePageSize: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.FlexTablePagination = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 200px;
  flex-grow: 1;
  align-items: flex-start;
  justify-content: center;
`;

// Table Pagination
Styled.TablePagination = styled(MuiTablePagination)`
  .MuiTablePagination-toolbar{
    padding: 0px 0px;
    min-height: 30px;
  }

  .MuiTablePagination-select {
    padding-left: 0px;
  }

  .MuiInputBase-root {
    margin: 0 8px 0 0;
    /* font-family: 'Bryant Pro Regular'; */
    font-variant: tabular-nums;
    font-size:  ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.0175em;
    color: ${(props) => props.theme.colors.greyDark};
  }

  .MuiInputBase-input {
    padding: 6px 28px 6px 0px;
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLight};
  }

  .MuiTypography-root {
    /* font-family: 'Bryant Pro Regular'; */
    font-variant: tabular-nums;
    font-size:  ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0.0175em;
    color: ${(props) => props.theme.colors.greyDark};
  }

  /* Hide Previous/Next Buttons */
  .MuiTablePagination-actions {
    display: none;
  }

  /* Select Icon */
  .MuiSvgIcon-root {
    right: 0;
    position: absolute;
    pointer-events: none;
    font-size: 20px;
  }
`;

// Table Pagination w/Styles
const TablePagination = withStyles(() => ({
  menuItem: {
    padding: '0px 16px',
    minHeight: '40px',
    // fontFamily: 'Bryant Pro Regular',
    fontSize: Theme.typography.bodyText,
    fontWeight: 'normal',
    letterSpacing: '0.0175em',
    lineHeight: 'normal',
    whiteSpace: 'normal',
    color: Theme.colors.greyDark
  }
}))(Styled.TablePagination);

export default RowsPerPage;
